import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsWeightTrainingNormalSmall = React.forwardRef(
  ({ color = "currentColor", size = 24, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M21.4 13.913a2 2 0 01-2.83 0l-2.297-2.298-4.657 4.657 2.298 2.298a2 2 0 010 2.829L12.5 22.813a2 2 0 01-2.829 0l-.707-.707-1.207 1.207a2 2 0 01-2.828 0L.686 19.07a2 2 0 010-2.828l1.207-1.207-.707-.707a2 2 0 010-2.829L2.6 10.085a2 2 0 012.829 0l2.298 2.298 4.657-4.657-2.298-2.298a2 2 0 010-2.828L11.5 1.185a2 2 0 012.828 0l.708.707L16.243.685a2 2 0 012.828 0l4.243 4.243a2 2 0 010 2.828l-1.208 1.208.707.707a2 2 0 010 2.828zM12.913 2.6L11.5 4.014l8.485 8.485 1.414-1.414-2.121-2.121 2.621-2.622L17.657 2.1 16.45 3.307l2.828 2.828-1.414 1.414zm.884 6.54L9.14 13.797l1.06 1.06 4.658-4.656zM12.5 19.984L4.015 11.5 2.6 12.913l4.95 4.95-1.414 1.414-2.828-2.828L2.1 17.656l4.243 4.243 2.621-2.622 2.122 2.122z"
        fill=""
      />
    </svg>
  )
);
SvgSportsWeightTrainingNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsWeightTrainingNormalSmall;
